import { Model } from '../../_kernel/architecture'
import { Name } from '../../_kernel/Name'
import { Slug } from '../../_kernel/Slug'

export abstract class PropertyFilter extends Model {
  constructor(
    protected readonly _name: Name,
    protected readonly _slug: Slug
  ) {
    super()
  }

  get name() {
    return this._name.value
  }

  get slug() {
    return this._slug.value
  }

  toJSON() {
    return {
      name: this._name.value,
      slug: this._slug.value,
    }
  }

  static fromJSON<T extends PropertyFilter>(
    this: new (name: Name, slug: Slug) => T,
    { json }: { json: { name: string; slug: string } }
  ): T {
    return new this(Name.create({ value: json.name }), Slug.create({ value: json.slug }))
  }
}
